import Tour from './Tour.js';

export default Tour;
